export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Interior Designer, SJ Designs",
    content:
      "The attention to detail and craftsmanship in their chandeliers is unmatched. I've used Chandelier Luxe for multiple high-end residential projects, and they never fail to exceed expectations.",
    rating: 5,
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Hotel Development Director",
    content:
      "Their installation team's professionalism and expertise made our hotel renovation project seamless. The lighting solutions they provided have become a talking point among our guests.",
    rating: 5,
  },
  {
    id: 3,
    name: "Emma Rodriguez",
    role: "Home Owner",
    content:
      "The custom chandelier they created for our grand entrance is absolutely breathtaking. Their team's guidance throughout the selection and installation process was invaluable.",
    rating: 5,
  },
];
